const getHeader = (type = {}) => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  ...type,
});

export default getHeader;
